import ApiServer from "../ApiServer.js";
import * as Html from "../util/Html.ts";
import TPLog from "../widget/og.mustache";
import TPLogGiphy from "../widget/og-giphy.mustache";

  var 
    https = window.location.toString().indexOf('https')===0,
    cache = {};
  
  ApiServer.types.OpenGraphMedia.prototype.onDecode = function(){
    this.chosenUrl = https?this.secureUrl:this.url;
    this.isSmall = this.width && this.height && this.width*this.height < 10000; 
    if(this.width && this.height){
      this.deltaWidth = -(this.width/this.height*200 - 300)/2;
    }
  };
  ApiServer.types.OpenGraphDataBean.prototype.onDecode = function(){
    this.iframes = this.videos.filter(function(vid){
      return vid.type==='text/html';
    })
    
    this.videos = this.videos.filter(function(vid){
      return vid.type==='video/mp4';
    })
    this.useVideo = this.videos.length>0;
    this.useIframe = !this.useVideo && this.iframes.length>0;
    this.useImage = !this.useVideo && !this.useIframe && this.images.length;
    this.useNone = !this.useVideo && !this.useIframe && !this.useImage;
  };

  
  function init(node){
    var 
      href= node.attr('href');
    
    node.removeAttr('data-widget');
    
    
      ApiServer.webog(href,function(ogbean){
        cache[href] = ogbean;
        ogbean.askedURL = href;
        var targetHeight = node.height();
        if(!ogbean.useNone){
          if(node.attr('giphy')){
            node = Html.replaceWith(node,TPLogGiphy,ogbean);
          }else{
            node = Html.replaceWith(node,TPLog,ogbean);
          }
        }else{
          node.attr('target','_new');
          node.text(href)
        } 
        node.trigger('afterupdate',node.height()-targetHeight);
        
      },function(err){
        if(err.code==="502"){
          node.replaceWith(node.html());
        }else{
          console.log(err)
        }
      });
   
  }
  Html.registerWidget('widget/og',{init:init})

  export {
    cache,
    init
  }